import { ThemeType } from '../../utils/themes/ThemeProvider'

export type ClientDetailsSidePanelTextTone = 'primary' | 'secondary' | 'warning' | 'success' | 'error'

export const getClientDetailsSidePanelTextColor = (
  tone: ClientDetailsSidePanelTextTone = 'primary',
  theme: ThemeType,
) => {
  const colorByTone: Record<ClientDetailsSidePanelTextTone, string> = {
    primary: theme.colors.textPrimary,
    secondary: theme.colors.textSecondary,
    warning: theme.colors.textWarning,
    success: theme.colors.textSuccess,
    error: theme.colors.textError,
  }

  return colorByTone[tone]
}
